import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import DateFnsUtils from "@date-io/date-fns";

import { API, graphqlOperation } from "aws-amplify";
import { areaByActiveBySortKey } from "../../../graphql/reloadyard/custom-queries";
import { createInventorie } from "../../../graphql/mutations";

import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Hidden,
  InputAdornment,
  makeStyles,
  TextField as MuiTextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";

import {
  ArrayField,
  ArrayInput,
  AutocompleteInput,
  Button,
  Confirm,
  Datagrid,
  Edit,
  FileInput,
  FormDataConsumer,
  FormTab,
  FunctionField,
  IconButtonWithTooltip,
  Loading,
  minLength,
  minValue,
  number,
  NumberInput,
  RadioButtonGroupInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
  Toolbar,
  useDataProvider,
  useEditController,
  useNotify,
  useRedirect,
} from "react-admin";
import { useForm } from "react-final-form";

import {
  ArrivedAtIcon,
  AttachFileIcon,
  CalendarIcon,
  CollectedAtIcon,
  CopyDownIcon,
  CreatedAtIcon,
  EditIcon,
  PlacedAtIcon,
  ReleasedAtIcon,
  RemoveIcon,
  SaveIcon,
  SealIcon,
  TimerIcon,
  TimerOffIcon,
} from "../../../components/common/iconography";

import {
  CustomFields,
  CustomFieldsButton,
  CustomFieldsTallySheet,
  getCustomFieldsToSave,
} from "../../../components/common/CustomFields";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { CarrierNameInput } from "../../../components/common/CarrierNameInput";
import { CopyToClipboardButton } from "../../../components/common/CopyToClipboardButton";
import { FileField } from "../../../components/common/FileField";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HistoryTab } from "../../../components/common/HistoryTab";
import { NotesTab } from "../../../components/common/NotesTab";
import { GateCheckInControl } from "../gateCheckIns/GateCheckInControl";
import {
  canOfferManualGateCheckIn,
  isStagingManualGateCheckIn,
  wantsManualGateCheckIn,
} from "../gateCheckIns/gateCheckInUtils";
import { createStagedGateEdit } from "../gateCheckIns/stagedGateEdit";
import { useActiveGateCheckIn } from "../gateCheckIns/useActiveGateCheckIn";
import { useGateQueueTurn } from "../gateCheckIns/useGateQueueTurn";
import {
  canSetGateStatus,
  outOfTurnTooltip,
} from "../../../utils/gateQueueOrder";
import { sessionYardRunsDriverCheckIn } from "../../../utils/gateAccess";
import PhotoInput from "../../../components/common/PhotoInput";
import { BetaBadge, NewBadge } from "../../../components/common/FeatureBadges";
import { SmartTipIcon } from "../../../components/common/SmartTipIcon";
import { EventsCalendarDialog } from "../../../components/common/EventsCalendar";
import { Scheduler } from "../../../components/common/scheduler/Scheduler";
import { SignatureBlock } from "../../../components/common/SignatureBlock";

import { validateContainerNumber } from "./InboundCreate";
import {
  isAuthorized,
  logError,
  setupLocationMaps,
} from "../../../utils/appUtils";
import {
  ACCEPTED_FILES,
  AclType,
  CARLOT_PO_NO_CHARS,
  CarrierType,
  CarrierTypes,
  FilePaths,
  InboundState,
  InboundStatus,
  GateCheckInStatus,
  InventoryField,
  InventoryStatus,
  LotType,
  LotTypes,
  MAX_FILES,
  MAX_PHOTO_NUM_INBOUND,
  NoteType,
  ResourceType,
  TrueOrFalse,
  UnitWeightOptions,
  VALIDATION_MSG,
  Workflow,
} from "../../../utils/constants";
import { handleFileChange } from "../../../utils/fileUtils";
import {
  canPlaceInboundShipment,
  gatePlacementRefusal,
} from "../../../utils/shipmentPlacement";
import {
  filterAreas,
  filterZones,
  isBulkArea,
  isTrack,
} from "../../../utils/locationUtils";
import {
  fetchCarrierEquipmentTypes,
  getCommodityUnits,
  getRailEquipmentTypes,
  getTruckEquipmentTypes,
  getUnitName,
  getWeightUOM,
  isBulkCommodity,
  isBulkShipment,
  isInventoryFieldVisible,
  unitOptionRenderer,
} from "../../../utils/loadTypeUtils";
import {
  getHoursMinutesDuration,
  getYardCalendarDaysInclusive,
  resolveScheduledDateTime,
  getDateTimeFromUtc,
} from "../../../utils/dateUtils";
import {
  deepRedirect,
  exceptionRenderer,
  normalizeValue,
  trimDecimal,
} from "../../../utils/utils";

import {
  fetchInboundBillingRules,
  filterApplicableManualRules,
  getManualRuleChoices,
} from "../accounts/chargeRules/ChargeRuleUtils";
import { ChargeEvent } from "../accounts/chargeRules/chargeRuleConstants";
import { InventoryStatusIcon } from "../inventory/InventoryStatusIcon";
import { handleInventoryDelete, showWeight } from "../inventory/InventoryUitls";
import { AdviceProcessingEditForm } from "./advice/AdviceProcessingEditForm";
import { InboundAside } from "./InboundAside";
import { DialogSaveButton } from "./DialogSaveButton";
import { DeepDeleteButton } from "./DeepDeleteButton";
import InboundEditActions from "./InboundEditActions";
import { ChecklistForm } from "./ChecklistForm";
import {
  SealNumbersCreateDialog,
  SealNumbersDialog,
} from "./SealNumbersDialog";
import {
  AddCatalogUploadButtons,
  applyManualRuleDefaultQuantity,
  autogenLotNumber,
  calcNetWeight,
  calcTotalQuantity,
  fetchDuplicateInbounds,
  getAutoCharges,
  getInboundBackPath,
  getInfoBubble,
  getManualChargeAmount,
  handleAreaChange,
  handleCommodityChange,
  handleContainerDropChange,
  handleContainerNumberChange,
  handleInventoriesQty,
  handleInventoriesWeight,
  handleLotTypeChange,
  handleSITChange,
  handleUnitChange,
  isContainerDropEnabled,
  isReleaseBlockedByCommitment,
  isSITDisabled,
  updateLambdaInboundMini,
  validatePoNumberUnicity,
  validateRailCarNumberUnicity,
} from "./InboundUtils";
import { isBrokeredAccount } from "../accounts/AccountUtils";
import { AccountTypeIcon } from "../../../components/common/AccountTypeIcon";

const useStyles = makeStyles((theme) => ({
  arrayInput: {
    marginTop: theme.spacing(0),
  },
  arrayInputHeader: {
    display: "flex",
    marginTop: theme.spacing(1),
    marginBottom: -theme.spacing(1),
    justifyContent: "space-between",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
  booleanInput: {
    marginLeft: theme.spacing(1),
  },
  statusIcon: {
    marginTop: theme.spacing(2),
  },
}));

const validateRequired = required();
const validatePoNo = [required(), minLength(CARLOT_PO_NO_CHARS)];
const validateLadenWeight = (value) =>
  required()(value) ||
  number()(value) ||
  minValue(0, "Must be greater than 0")(value);
const validateLoadedMinNum = (value) =>
  number()(value) || minValue(0, "Must be greater than 0")(value);
const isLadenWeightRequired = (formData) => formData.tareWeight;

const validateQuantity = [required(), number(), minValue(0)];
const validatePieces = [number(), minValue(1)];

const tareWeightValidator = (value, allValues) => {
  // return an object just like the other validators
  if (
    allValues.ladenWeight &&
    allValues.releaseDateTime &&
    value !== 0 &&
    !value
  )
    return { message: `Required`, isRequired: true };
  if (value > allValues.ladenWeight) {
    return { message: `Tare weight must be less than laden weight.` };
  }
  return undefined;
};
const validateTareWeight = [
  number(),
  minValue(0, "Must be greater than 0"),
  tareWeightValidator,
];
const isTareWeightRequired = (formData) =>
  formData.ladenWeight && formData.releaseDateTime;

const validateRailCarNumber = (value, allValues) => {
  // On a truck this field is the trailer number, which the gate asks every
  // driver for: it becomes the check-in row's Trl # and is what gate placement
  // reads, so the office checking a truck in owes it too.
  if (
    (allValues?.carrierType === CarrierType.RAIL ||
      allValues?.placedDateTime ||
      isStagingManualGateCheckIn(allValues, false)) &&
    !value
  ) {
    // return an object just like the other validators
    return { message: `Required`, isRequired: true };
  }
  return undefined;
};
const isRailcarNumberRequired = (formData) =>
  validateRailCarNumber(null, formData) ? true : false;

const validateCarrierName = (value, allValues) => {
  const requiredByPlacement =
    allValues?.carrierType === CarrierType.TRUCK && allValues?.placedDateTime;
  // A truck the office is checking in at the gate names its carrier too — the
  // check-in row the save mints carries it to a crew who see no shipment.
  if (
    (requiredByPlacement || isStagingManualGateCheckIn(allValues, false)) &&
    !value
  ) {
    // return an object just like the other validators
    return { message: `Required`, isRequired: true };
  }
  return undefined;
};
const isCarrierNameRequired = (formData) =>
  validateCarrierName(null, formData) ? true : false;

const validateTallySheetSaved = (data) => {
  let unSaved = false;
  unSaved = data.some(
    (e) => typeof e === `undefined` || e.status === InventoryStatus.NEW,
  );
  return unSaved;
};

const validateTallyRowQty = (data) => {
  const errors = {};
  if (
    data &&
    data.quantityReceived &&
    data.quantityReceived !== "" &&
    data.quantityAdvised !== data.quantityReceived
  ) {
    errors.quantity = true;
    errors.helperText = " Qty. Advised & Received should be equal.";
  }
  return errors;
};

// check if Qty. advised & received are equal. Warning only, no Validation Errors.
const validateTallyQty = (formData) => {
  debugger;
  let qtyWarning = false;
  if (
    ((formData.status === InboundStatus.PLACED && formData.placedDateTime) ||
      formData.status === InboundStatus.AGGREGATED) &&
    formData.state !== InboundState.APPROVE_SHIPMENT &&
    formData.inventories?.items
  ) {
    formData.inventories.items.forEach((row) => {
      if (row?.status !== InboundStatus.IN_TRANSIT) {
        // NumberInput can leave these as strings in form state; coerce before
        // arithmetic/comparison so `+` doesn't concatenate and `!==` doesn't
        // fail on a string-vs-number type mismatch.
        const quantityAdvised = Number(row.quantityAdvised || 0);
        const quantityReceived = Number(row.quantityReceived || 0);
        let netReceived = quantityReceived;

        if (row.overShipment || row.underShipment) {
          // manager can zero out inventory without setting exception for BULK
          const underShipmentQuantity = Number(row.underShipmentQuantity || 0);
          const overShipmentQuantity = Number(row.overShipmentQuantity || 0);
          netReceived = trimDecimal(
            quantityReceived + underShipmentQuantity - overShipmentQuantity,
          );
        }
        if (quantityAdvised !== netReceived) {
          qtyWarning = true;
        }
      }
    });
  }
  return qtyWarning;
};

const isQuantityReceivedRequired = (formData, data) => {
  return (
    formData?.state &&
    formData?.state !== InboundState.NEW &&
    formData?.state !== InboundState.PROCESS_SHIPMENT &&
    formData?.state !== InboundState.APPROVE_SHIPMENT &&
    (data.status === InventoryStatus.NEW ||
      data.verificationRequired === "true") &&
    !isBulkShipment(formData?.reloadYardCommodity.commodity, formData?.areaId)
  );
};

// Validate Tally Sheet Row and return Validation Errors that will prevent form submission
const validateTallySheetRow = (record, data) => {
  const errors = {};
  let helperText = false;
  if (data) {
    if (!data.productName || data.productName === "") {
      errors.productName = true;
      helperText = "Product Name is required.";
    }
    if (!data.quantityAdvised || data.quantityAdvised <= 0) {
      errors.quantityAdvised = true;
      helperText = "Qty. Advised must be greater than 0.";
    }
    if (data.weightUnits && (!data.weight || data.weight <= 0)) {
      errors.weight = true;
      helperText = "Weight must be greater than 0.";
    }
  }

  if (helperText) errors.helperText = helperText;
  return errors;
};

// Validate form and return error to prevent form submission
const validateInboundEdit = (record, values) => {
  const errors = {};

  // Validate Tally Sheet Form and return Validation Errors
  // Important: errors must be nested under inventories.items[index] so react-admin can
  // highlight the correct ArrayInput fields and tabs.
  if (values?.inventories?.items?.length) {
    const items = [];

    values.inventories.items.forEach((row, index) => {
      const rowErrors = validateTallySheetRow(record, row);
      if (!rowErrors?.helperText) return;

      const { helperText, ...fieldFlags } = rowErrors;

      // react-admin/react-final-form expects field errors to be strings (or arrays of strings),
      // not booleans. We keep booleans for the manual `error={...}` props on inputs, but for the
      // form-level validator we map each failing field to the helperText message.
      const fieldErrors = Object.keys(fieldFlags).reduce((acc, key) => {
        if (fieldFlags[key]) acc[key] = helperText;
        return acc;
      }, {});

      items[index] = fieldErrors;
    });

    if (items.length > 0) {
      errors.inventories = { items };
    }
  }

  // validate carrier name and number
  if (values.carrierType === CarrierType.RAIL) {
    // if (!values.carrierName) errors.carrierName = "Required";
    if (!values.railCarNumber) errors.railCarNumber = "Required";
  }

  return errors;
};

const ShipmentSetupTab = ({
  record,
  backPath,
  receiptFile,
  exceptions,
  yardCommodity,
  setYardCommodity,
  SetAllSealsValid,
  photos,
  setPhotos,
  ...props
}) => {
  const form = useForm();
  const notify = useNotify();
  const [lotNumber, setLotNumber] = useState(
    record.lotNumberOverride === true ? record.lotNumber : "",
  );
  const [areas, setAreas] = useState(
    window.appUser.reloadYard?.areas.items.filter(
      (itm) => itm.active === "true",
    ),
  );
  const [area, setArea] = useState(record.area);
  const [open, setOpen] = useState(false);
  const [duplicatePoNumber, setDuplicatePoNumber] = useState(null);
  const [railEquipmentChoices, setRailEquipmentChoices] = useState(
    getRailEquipmentTypes(),
  );
  const [truckEquipmentChoices, setTruckEquipmentChoices] = useState(
    getTruckEquipmentTypes(),
  );
  const [carrierEquipmentChoices, setCarrierEquipmentChoices] = useState(
    record?.carrierType === CarrierType.RAIL
      ? railEquipmentChoices
      : record?.carrierType === CarrierType.TRUCK
        ? truckEquipmentChoices
        : [],
  );
  const yardCommodities = window.appUser.reloadYard.activeYardCommodities.items;

  useEffect(() => {
    getSetupData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  useEffect(() => {
    if (record?.area?.zones) setArea(record.area);
  }, [record.area]);

  useEffect(() => {
    if (receiptFile?.key) form.change("receiptFile", receiptFile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiptFile]);

  useEffect(() => {
    const validateInitialPoNumber = async () => {
      const hasDuplicatePoNumber = await fetchDuplicateInbounds(record);
      setDuplicatePoNumber(hasDuplicatePoNumber);
    };

    validateInitialPoNumber();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Subscribe to field state updates for 3rd party inputs
  form.registerField(
    "hasException",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "unsafeShipment",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "unsafeShipmentNote",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "brokenSeal",
    (fieldState) => {
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "brokenSealNote",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "otherException",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "otherExceptionNote",
    (fieldState) => {
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );

  form.registerField(
    "checklist",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "sealNumbers",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );

  useEffect(() => {
    form.change("hasException", exceptions?.hasException);
    form.change("unsafeShipment", exceptions?.unsafeShipment);
    form.change("unsafeShipmentNote", exceptions?.unsafeShipmentNote);
    form.change("brokenSeal", exceptions?.brokenSeal);
    form.change("brokenSealNote", exceptions?.brokenSealNote);
    form.change("otherException", exceptions?.otherException);
    form.change("otherExceptionNote", exceptions?.otherExceptionNote);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exceptions]);

  const getSetupData = async () => {
    try {
      const areaPromise = API.graphql(
        graphqlOperation(areaByActiveBySortKey, {
          reloadYardId: window.appUser?.reloadYardId,
          activeSortKey: { beginsWith: { active: "true" } },
          limit: 1000,
        }),
      );
      const carrierEquipmentPromise = fetchCarrierEquipmentTypes();

      // Use Promise.all to wait for both promises to resolve
      const [areaResp, carrierEquipmentResp] = await Promise.all([
        areaPromise,
        carrierEquipmentPromise,
      ]);

      const carrierEquipment = carrierEquipmentResp;
      let areas = areaResp.data.areaByActiveBySortKey.items;
      window.appUser.reloadYard.areas.items = areas;
      setupLocationMaps(window.appUser.reloadYard);
      const reloadYardCommodityId = form.getFieldState(
        "reloadYardCommodityId",
      )?.value;
      areas = filterAreas(areas, reloadYardCommodityId);

      setAreas(areas);
      setRailEquipmentChoices(carrierEquipment.railEquipmentTypes);
      setTruckEquipmentChoices(carrierEquipment.truckEquipmentTypes);

      if (record.carrierType === CarrierType.RAIL) {
        setCarrierEquipmentChoices(carrierEquipment.railEquipmentTypes);
      } else if (record.carrierType === CarrierType.TRUCK) {
        setCarrierEquipmentChoices(carrierEquipment.truckEquipmentTypes);
      } else {
        setCarrierEquipmentChoices([]);
      }
    } catch (error) {
      logError("inboundShipment:InboundEdit:getSetupData", error, notify);
    }
  };

  const handleCarrierTypeChange = (event) => {
    const carrier = event?.target?.value;
    const formData = form.getState().values;

    if (carrier === CarrierType.RAIL) {
      setCarrierEquipmentChoices(railEquipmentChoices);
      const trackArea = (areas || []).find((currentArea) =>
        isTrack(currentArea?.id),
      );
      if (trackArea) {
        const newArea = {
          ...trackArea,
          zones: { ...trackArea.zones },
        };
        const reloadYardCommodityId = form.getFieldState(
          "reloadYardCommodityId",
        )?.value;
        newArea.zones.items = filterZones(
          newArea.zones?.items || [],
          reloadYardCommodityId,
          record.accountId,
        );
        setArea(newArea);
        form.change("areaId", trackArea.id);
        if (newArea.zones.items?.length === 1)
          form.change("zoneId", newArea.zones.items[0].id);
        else form.change("zoneId", "");
      } else {
        setArea(null);
        form.change("areaId", "");
        form.change("zoneId", "");
      }
    } else if (carrier === CarrierType.TRUCK) {
      setCarrierEquipmentChoices(truckEquipmentChoices);
      const currentAreaId = form.getFieldState("areaId")?.value;
      if (currentAreaId && isTrack(currentAreaId)) {
        setArea(null);
        form.change("areaId", "");
        form.change("zoneId", "");
      }

      if (formData.sit) {
        form.change("sit", false);
        notify("SIT has been disabled", "warning");
      }
    } else {
      setCarrierEquipmentChoices([]);
    }
    form.change("carrierEquipmentTypeId", "");

    // Only trucking companies are Carrier records, so a rail load has no id to
    // hold. Left behind, it would keep pointing at the trucking company while
    // the free-text field the rail branch renders renames the load out from
    // under it.
    if (carrier !== CarrierType.TRUCK) form.change("carrierId", null);
  };

  const handlePoNumberChange = (event, formData) => {
    const value = event.target.value?.toUpperCase() || "";
    setDuplicatePoNumber(null);
    if (formData.state === InboundState.COMPLETED) return;
    if (formData.lotType === LotType.PERPETUAL) return;
    if (formData.lotNumberOverride === true) return;

    const nextFormData = { ...formData, poNumber: value };
    form.change(
      "lotNumber",
      autogenLotNumber(formData.lotType, nextFormData, formData.account),
    );
  };

  const handlePoNumberBlur = async () => {
    const hasDuplicatePoNumber = await validatePoNumberUnicity(
      form.getState().values,
      notify,
    );
    setDuplicatePoNumber(hasDuplicatePoNumber);
  };

  const handleRailCarNumberChange = (event, formData) => {
    const value = event.target.value?.toUpperCase() || "";
    if (formData.lotNumberOverride !== true && formData.lotType) {
      const nextFormData = { ...formData, railCarNumber: value };
      form.change(
        "lotNumber",
        autogenLotNumber(formData.lotType, nextFormData, formData.account),
      );
    }
  };

  const handleLotNoManualChange = (value, formData) => {
    debugger;
    if (value) form.change("lotNumber", lotNumber);
    else
      form.change(
        "lotNumber",
        autogenLotNumber(formData.lotType, formData, formData.account),
      );
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getSealNumberButtonLabel = (formData) => {
    return `Manage Seals (${
      formData?.seals?.items.length || formData?.sealNumbers?.length || 0
    })`;
  };

  const canEditContainerData = record.inventories?.items?.some(
    (inventory) => inventory.status !== InventoryStatus.UNLOADED,
  );

  const getPoNumberHelperText = () => {
    if (!duplicatePoNumber) return false;
    return "⚠️ Duplicate PO Number.";
  };

  const isZoneRequired = () => {
    const isReleased = record?.status === InboundStatus.RELEASED;
    const isRequired = record?.account?.requireDefaultZone;
    return isRequired && !isReleased;
  };

  const isCarriertypeDisabled = (formData) => {
    return formData.state === InboundState.COMPLETED || formData.sit;
  };

  const isAreaZoneDisabled = (formData) => {
    return (
      formData.state === InboundState.COMPLETED ||
      (formData.sit && formData.status === InboundStatus.SIT_PLACED)
    );
  };

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => {
        if (formData.status === "ADVICE_PROCESSING") {
          return (
            <AdviceProcessingEditForm
              form={form}
              notify={notify}
              yardCommodities={yardCommodities}
              isBrokeredAccount={isBrokeredAccount}
              record={record}
              area={area}
              setAreas={setAreas}
              setYardCommodity={setYardCommodity}
              handleCarrierTypeChange={handleCarrierTypeChange}
            />
          );
        } else {
          return (
            <Grid container direction="column" spacing={0}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="accountName"
                    label="Account"
                    variant="outlined"
                    disabled
                    fullWidth
                    helperText={false}
                    InputProps={{
                      endAdornment: (
                        <AccountTypeIcon account={record?.account} />
                      ),
                    }}
                  />
                </Grid>
                {isBrokeredAccount(record.account) && (
                  <Grid item xs={12} md={4}>
                    <AccountDropDown
                      source="billToAccountId"
                      label="Billing Account"
                      validate={validateRequired}
                      allowEmpty={false}
                      disabled={true}
                      helperText={false}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="shipFrom"
                    label="Origin"
                    variant="outlined"
                    fullWidth
                    disabled={formData.state === InboundState.COMPLETED}
                    helperText={false}
                    validate={validateRequired}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="poNumber"
                    label="PO Number"
                    variant="outlined"
                    fullWidth
                    parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                    disabled={Boolean(record?.invoiceId?.trim())}
                    validate={validatePoNo}
                    onChange={(event) => handlePoNumberChange(event, formData)}
                    onBlur={handlePoNumberBlur}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <CopyToClipboardButton
                            text={formData.poNumber || ""}
                            edge="end"
                            fontSize="small"
                            mb={0}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={Boolean(duplicatePoNumber)}
                    helperText={getPoNumberHelperText()}
                    FormHelperTextProps={{
                      component: "div",
                      style: duplicatePoNumber
                        ? { color: "#f44336" }
                        : undefined,
                    }}
                  />
                </Grid>
                {formData?.account?.trackInboundSeals && (
                  <Grid item xs={12} md={4}>
                    <Box mt={1}>
                      <Button
                        label={getSealNumberButtonLabel(formData)}
                        onClick={handleOpen}
                        variant="outlined"
                        size="large"
                      >
                        <SealIcon />
                      </Button>
                    </Box>
                  </Grid>
                )}
              </Grid>

              <Grid container item spacing={2}>
                <Grid item xs={12} md={4}>
                  <AutocompleteInput
                    source="reloadYardCommodityId"
                    label="Load Type"
                    variant="outlined"
                    fullWidth
                    choices={yardCommodities}
                    optionText={(choice) =>
                      `${choice.commodity.name} - ${choice.units}`
                    }
                    optionValue="id"
                    validate={validateRequired}
                    disabled={
                      formData.inventories?.items?.length > 0 ||
                      formData.status === InboundStatus.RELEASED
                    }
                    onChange={(value) =>
                      handleCommodityChange(
                        value,
                        form,
                        setYardCommodity,
                        area,
                        setAreas,
                      )
                    }
                    helperText={false}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <SelectInput
                    source="carrierType"
                    label="Carrier Type"
                    disabled={isCarriertypeDisabled(formData)}
                    choices={CarrierTypes}
                    onChange={handleCarrierTypeChange}
                    validate={validateRequired}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
                {(railEquipmentChoices?.length > 0 ||
                  truckEquipmentChoices?.length > 0) && (
                  <Grid item xs={12} md={4}>
                    <SelectInput
                      source="carrierEquipmentTypeId"
                      label="Carrier Equipment Type"
                      choices={carrierEquipmentChoices}
                      allowEmpty
                      fullWidth
                      disabled={!carrierEquipmentChoices?.length}
                      variant="outlined"
                      helperText={false}
                    />
                    <SmartTipIcon label="carrier-equipment-type" mt={-1} />
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  {/* Only trucking companies exist as Carrier records, so only a
                      truck load has a list to pick from. A rail carrier name is
                      the railroad's mark — free text with no record behind it —
                      and it stays a plain field. */}
                  {formData.carrierType === CarrierType.TRUCK ? (
                    <CarrierNameInput
                      source="carrierName"
                      label="Carrier Name"
                      disabled={
                        record.carrierName &&
                        record.status === InboundStatus.RELEASED
                      }
                      validate={validateCarrierName}
                      isRequired={isCarrierNameRequired(formData)}
                    />
                  ) : (
                    <TextInput
                      source="carrierName"
                      label="Carrier Name"
                      variant="outlined"
                      fullWidth
                      disabled={
                        record.carrierName &&
                        record.status === InboundStatus.RELEASED
                      }
                      validate={validateCarrierName}
                      isRequired={isCarrierNameRequired(formData)}
                      helperText={false}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="railCarNumber"
                    label={
                      formData.carrierType === CarrierType.RAIL
                        ? "Railcar Number"
                        : "Trailer Number"
                    }
                    variant="outlined"
                    fullWidth
                    disabled={
                      record.railCarNumber &&
                      record.status === InboundStatus.RELEASED
                    }
                    parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                    validate={validateRailCarNumber}
                    required={isRailcarNumberRequired(formData)}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <CopyToClipboardButton
                            text={formData.railCarNumber || ""}
                            edge="end"
                            fontSize="small"
                            mb={0}
                          />
                        </InputAdornment>
                      ),
                    }}
                    helperText={false}
                    onChange={(event) =>
                      handleRailCarNumberChange(event, formData)
                    }
                    onBlur={() =>
                      validateRailCarNumberUnicity(formData, notify)
                    }
                  />
                </Grid>
                {formData?.containerDrop && (
                  <Grid item xs={12} md={4}>
                    <TextInput
                      source="containerNumber"
                      label="Container Number"
                      variant="outlined"
                      fullWidth
                      disabled={!canEditContainerData}
                      parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                      onChange={(event) =>
                        handleContainerNumberChange(event.target.value, form)
                      }
                      validate={validateContainerNumber}
                      inputProps={{ style: { textTransform: "uppercase" } }}
                      helperText={false}
                    />
                  </Grid>
                )}
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <SelectInput
                    source="areaId"
                    label="Default Area"
                    variant="outlined"
                    fullWidth
                    disabled={formData.sit || isAreaZoneDisabled(formData)}
                    choices={areas || []}
                    onChange={(event) =>
                      handleAreaChange(
                        event.target.value,
                        areas,
                        setArea,
                        form,
                        notify,
                      )
                    }
                    validate={validateRequired}
                    helperText={false}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <SelectInput
                    source="zoneId"
                    label="Default Zone"
                    variant="outlined"
                    fullWidth
                    disabled={!area || isAreaZoneDisabled(formData)}
                    choices={
                      area?.zones?.items?.filter(
                        (zone) =>
                          !zone.accountId ||
                          zone.accountId === record.accountId,
                      ) || []
                    }
                    allowEmpty={!isZoneRequired()}
                    validate={isZoneRequired() ? validateRequired : undefined}
                    helperText={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <SelectInput
                    source="lotType"
                    label="Lot Type"
                    variant="outlined"
                    fullWidth
                    disabled={formData.state === InboundState.COMPLETED}
                    choices={LotTypes}
                    validate={validateRequired}
                    onChange={(event) =>
                      handleLotTypeChange(
                        event.target.value,
                        form,
                        record.account,
                      )
                    }
                    helperText={false}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="lotNumber"
                    label="Lot Number"
                    variant="outlined"
                    fullWidth
                    disabled={
                      formData.lotNumberOverride !== true ||
                      formData.returnShipment ||
                      formData.state === InboundState.COMPLETED
                    }
                    validate={validateRequired}
                    onChange={(event) => setLotNumber(event.target.value)}
                    parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                    helperText={false}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                  />
                </Grid>
              </Grid>
              <CustomFields
                {...props}
                recordFields={record.customFields}
                accountFields={record?.account?.inboundCustomFields}
                width={4}
                disabled={formData.status === InboundStatus.RELEASED}
              />
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <fieldset>
                    <legend>
                      <Typography variant="overline" color="textSecondary">
                        Options
                      </Typography>
                    </legend>
                    <Grid container direction="row" spacing={0}>
                      <Grid item xs={6} md={3}>
                        <RadioButtonGroupInput
                          source="lotNumberOverride"
                          label="Lot # Override"
                          row
                          choices={TrueOrFalse}
                          defaultValue={false}
                          disabled={
                            formData.stockImport ||
                            formData.returnShipment ||
                            formData.state === InboundState.COMPLETED
                          }
                          onChange={(value) =>
                            handleLotNoManualChange(value, formData)
                          }
                          helperText={false}
                        />
                      </Grid>
                      {!formData.sit && (
                        <Grid item xs={6} md={3}>
                          <RadioButtonGroupInput
                            source="secondaryReview"
                            label="Secondary Review"
                            row
                            choices={TrueOrFalse}
                            defaultValue={false}
                            disabled={
                              formData.sit ||
                              formData.containerDrop ||
                              formData.state === InboundState.COMPLETED
                            }
                            validate={validateRequired}
                            helperText={false}
                          />
                        </Grid>
                      )}
                      <Grid item xs={6} md={3}>
                        <RadioButtonGroupInput
                          source="skipInvoice"
                          label="Skip Billing"
                          row
                          choices={TrueOrFalse}
                          defaultValue={false}
                          disabled={Boolean(record?.invoiceId?.trim())}
                          validate={validateRequired}
                          helperText={false}
                        />
                      </Grid>
                      {!formData.sit && (
                        <Grid item xs={6} md={3}>
                          <RadioButtonGroupInput
                            source={
                              record?.returnShipment
                                ? "returnShipment"
                                : "stockImport"
                            }
                            label={
                              record?.returnShipment
                                ? "Return Shipment"
                                : "Stock Import"
                            }
                            choices={TrueOrFalse}
                            row
                            disabled
                            helperText={false}
                          />
                        </Grid>
                      )}
                      {!formData.sit && (
                        <Grid item xs={6} md={3}>
                          <RadioButtonGroupInput
                            source="containerDrop"
                            label="ISOtainer Drop"
                            row
                            choices={TrueOrFalse}
                            defaultValue={false}
                            validate={validateRequired}
                            disabled={!isContainerDropEnabled(formData, area)}
                            onChange={(value) =>
                              handleContainerDropChange(value, form)
                            }
                            helperText={false}
                          />
                          <BetaBadge />
                        </Grid>
                      )}
                      <Grid item xs={6} md={3}>
                        <RadioButtonGroupInput
                          source="sit"
                          label="SIT"
                          row
                          choices={TrueOrFalse}
                          defaultValue={false}
                          onChange={(value) =>
                            handleSITChange(
                              value,
                              form,
                              record.account,
                              setArea,
                            )
                          }
                          validate={validateRequired}
                          disabled={isSITDisabled(formData)}
                          helperText={false}
                        />
                        <BetaBadge />
                      </Grid>
                    </Grid>
                  </fieldset>
                </Grid>
              </Grid>
              <Grid container direction="row" spacing={2}>
                <Hidden smDown>
                  <Grid item xs={6}>
                    <FileInput
                      source="attachments"
                      label="ATTACHMENTS"
                      variant="outlined"
                      fullWidth
                      placeholder={
                        <p>
                          <AttachFileIcon fontSize="large" /> <br /> Drop files
                          to upload, or click to select.
                        </p>
                      }
                      accept={ACCEPTED_FILES}
                      multiple
                      maxFiles={MAX_FILES}
                      options={{ maxFiles: MAX_FILES }}
                      onChange={(value) =>
                        handleFileChange("attachments", value, form, notify)
                      }
                    >
                      <FileField source="src" title="title" target="_blank" />
                    </FileInput>
                  </Grid>
                </Hidden>
                <Grid item xs={12} md={6}>
                  <FileInput
                    source="receiptFile"
                    label="RECEIPT FILE"
                    variant="outlined"
                    fullWidth
                    placeholder={
                      <p>
                        <AttachFileIcon fontSize="large" /> <br /> Create
                        Receipt, or drop a File to upload, or click to select.
                      </p>
                    }
                    accept="image/*,.pdf,.docx"
                    onChange={(value) =>
                      handleFileChange("receiptFile", value, form, notify)
                    }
                    disabled={false}
                  >
                    <FileField source="src" title="title" download />
                  </FileInput>
                </Grid>
                <Hidden smDown>
                  <Grid item xs={12}>
                    <PhotoInput
                      source="photos.items"
                      label="PHOTOS"
                      maxFiles={MAX_PHOTO_NUM_INBOUND}
                      parentType={ResourceType.INBOUND}
                      storeDir={`${FilePaths.INBOUND}/${Date.now()}`}
                      photos={photos}
                      setPhotos={setPhotos}
                    />
                  </Grid>
                </Hidden>
              </Grid>
              {formData?.seals?.items?.length === 0 ? (
                <SealNumbersCreateDialog
                  open={open}
                  onClose={handleClose}
                  formData={formData}
                />
              ) : (
                <SealNumbersDialog
                  open={open}
                  onClose={handleClose}
                  SetAllSealsValid={SetAllSealsValid}
                  formData={formData}
                />
              )}
            </Grid>
          );
        }
      }}
    </FormDataConsumer>
  );
};

const EditRemoveButton = ({
  record,
  form,
  saving,
  setSaving,
  setWeightError,
  yardCommodity,
  backPath,
  ...props
}) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const redirect = useRedirect();
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [open, setOpen] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState("");
  const [confirmContent, setConfirmContent] = useState("");

  var n = props.className.lastIndexOf("-");
  var index = Number(props.className.substring(n + 1));
  const source = `inventories.items[${index}]`;
  const fieldState = form.getFieldState("inventories.items");
  const data = fieldState?.value[index];
  const toPath = data ? "/inventories/" + data.id : "";

  const handleConfirmOpen = (evt) => {
    const formState = form.getState();
    debugger;

    if (fieldState.dirty) {
      let unSaved = validateTallySheetSaved(fieldState.value);

      if (unSaved) {
        evt.preventDefault();
        setConfirmTitle("Un-saved Data Confirmation");
        setConfirmContent(
          "You have un-saved Tally Sheet Items. Navigating away will lose un-saved changes. Continue?",
        );
        setOpen(true);
        return;
      }
    }

    if (formState.dirty) {
      evt.preventDefault();
      setConfirmTitle("Un-saved Data Confirmation");
      setConfirmContent(
        "You have un-saved shipment changes. If you continue, all changes will be lost. Proceed?",
      );
      setOpen(true);
      return;
    }

    handleConfirmRedirect();
  };

  const handleConfirmClose = () => setOpen(false);
  const handleConfirmRedirect = () => {
    const formState = form.getState();
    const advice = formState?.values?.status?.startsWith(
      InboundStatus.ADVICE_ALL,
    )
      ? "?advice=true"
      : "";
    deepRedirect(history, toPath + advice, backPath, {
      inboundRecord: formState.values,
    });
  };

  const handleCopy = () => {
    if (fieldState?.value) {
      debugger;
      const newRow = {
        status: InventoryStatus.NEW,
        productName: data.productName,
        productCode: data.productCode,
        productId: data.productId ? data.productId : "",
        product: data.product,
        quantityAdvised: data.quantityAdvised,
        quantityReceived: data.quantityReceived,
        // pcs: data.pcs, // commented out to keep product default
        reloadYardCommodityId: data.reloadYardCommodityId,
        pcsHeight: data.pcsHeight,
        pcsWidth: data.pcsWidth,
        pcsLength: data.pcsLength,
        weight: data.weight,
        weightUnits: data.weightUnits,
        weightUOM: data.weightUOM,
        customFields: data.customFields,
      };
      form.change("inventories.items", [...fieldState.value, newRow]);
      handleInventoriesQty(form);
      handleInventoriesWeight(form, setWeightError);
    }
  };

  const handleRemove = async (event) => {
    setSaving(true);

    debugger;
    try {
      if (data?.id) {
        await handleInventoryDelete(data, dataProvider);
        props.onClick(event);
      } else props.onClick(event);

      if (data?.id) notify("Item deleted successfully", "success");
    } catch (err) {
      logError(
        "inboundEdit:EditRemoveButton:handleRemove",
        err,
        notify,
        redirect,
      );
    }

    handleInventoriesQty(form);
    handleInventoriesWeight(form, setWeightError);
    setSaving(false);
  };

  const gerYardCommodityId = (data) => {
    debugger;
    return data.productId && data.reloadYardCommodityId
      ? data.reloadYardCommodityId
      : yardCommodity.id;
  };

  const handleSave = async () => {
    setSaving(true);
    debugger;
    try {
      const formState = form.getState();
      const formData = formState.values;
      if (validateTallySheetRow(record, data).helperText) {
        notify(VALIDATION_MSG, "warning");
        setSaving(false);
        return;
      }

      // OK to use potentially stale record because all inventories get updated on inbound save.
      let input = {
        inboundShipmentId: record.id,
        reloadYardId: record.reloadYardId,
        accountId: record.accountId,
        accountName: record.accountName,
        groups: record.groups,
        active: record.active,
        areaId: formData.areaId || " ",
        zoneId: formData.zoneId || " ",
        poNumber: formData.poNumber,
        productName: data.productName,
        quantityAdvised: data.quantityAdvised,
        quantityCommitted: 0,
        pcs: data.pcs,
        pcsHeight: data.pcsHeight,
        pcsWidth: data.pcsWidth,
        pcsLength: data.pcsLength,
        inventoryUOM: record.totalUOM,
        weight: data.weight,
        weightUOM: data.weightUOM,
        sortKey: index + 10001,
      };

      input.productCode = data.productCode ? data.productCode : null;
      input.productId = data.productId ? data.productId : "";
      input.reloadYardCommodityId = gerYardCommodityId(data);

      input.lotType = formData.lotType ? formData.lotType : "";
      input.lotNumber = formData.lotType ? formData.lotNumber : "";
      input.normalizedPoNumber = normalizeValue(formData.poNumber);
      input.normalizedRailCarNumber = normalizeValue(formData.railCarNumber);

      if (record.placedDateTime && record.placedDateTime !== "") {
        input.receivedAt = record.placedDateTime;
      }

      if (data.quantityReceived && data.quantityReceived !== "")
        input.quantityReceived = data.quantityReceived;
      if (data.quantityOnHand && data.quantityOnHand !== "")
        input.quantityOnHand = data.quantityOnHand;

      input.history = [
        {
          text: `Created Inventory.`,
          type: NoteType.GENERIC,
          date: new Date(),
          by: window.appUser?.fullName,
        },
      ];

      if (!record?.state || record?.state === InboundState.NEW) {
        input.status = InventoryStatus.IN_TRANSIT;
      } else if (record.state === InboundState.COMPLETED) {
        input.status = InventoryStatus.STORED;
      } else {
        input.status = InventoryStatus.ARRIVED;
        input.verificationRequired = "false";
      }

      input.customFields = getCustomFieldsToSave(
        data.customFields,
        record.account.inventoryCustomFields,
      );

      const resp = await API.graphql(
        graphqlOperation(createInventorie, { input }),
      );
      const newLineItem = resp.data.createInventorie;
      form.change(source, newLineItem);

      formData.inventories.items =
        formData.inventories.items.concat(newLineItem);

      notify("Tally Sheet Item saved successfully", "success");
    } catch (error) {
      logError(
        "inboundShipments:InboundEdit:EditRemoveButton:handleSave",
        error,
        notify,
        redirect,
      );
    }

    handleInventoriesQty(form);
    handleInventoriesWeight(form, setWeightError);
    setSaving(false);
  };

  return (
    <Grid
      container
      direction={xsDown ? "row" : "column"}
      spacing={1}
      alignItems="flex-end"
    >
      {data?.status &&
        data.status !== InventoryStatus.UNLOADED &&
        data.status !== InventoryStatus.STORED &&
        data.status !== InventoryStatus.AGGREGATED &&
        data.status !== InventoryStatus.SHIPPED && (
          <Grid item xs={2} sm={12}>
            <Button label="Remove" color="default" onClick={handleRemove}>
              <RemoveIcon />
            </Button>
          </Grid>
        )}
      {data?.status && data.status !== InventoryStatus.NEW && (
        <Grid item xs={2} sm={12}>
          {record.status !== InboundStatus.RELEASED &&
            !isBulkCommodity(yardCommodity?.commodity) && (
              <Tooltip title="Copy Down">
                <Button
                  label=""
                  color="default"
                  size="small"
                  onClick={handleCopy}
                >
                  <CopyDownIcon />
                </Button>
              </Tooltip>
            )}
          <Button label="Edit" color="primary" onClick={handleConfirmOpen}>
            <EditIcon />
          </Button>

          <Confirm
            isOpen={open}
            loading={saving}
            title={confirmTitle}
            content={confirmContent}
            onConfirm={handleConfirmRedirect}
            onClose={handleConfirmClose}
          />
        </Grid>
      )}

      {data && data.status && data.status === InventoryStatus.NEW && (
        <Grid item xs={2} sm={12}>
          <Button
            label="Save"
            color="primary"
            variant="contained"
            size="small"
            disabled={saving}
            onClick={handleSave}
          >
            <SaveIcon />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

const TallySheetTab = ({ record, backPath, yardCommodity, ...props }) => {
  const form = useForm();
  const classes = useStyles();
  const [weightError, setWeightError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [selectedFields, setSelectedFields] = useState(
    record.account?.inventoryCustomFields,
  );
  const [chargeRules, setChargeRules] = useState([]);
  const [autoCharges, setAutoCharges] = useState([]);

  useEffect(() => {
    if (record.selectedCustomFields)
      setSelectedFields(record.selectedCustomFields);
    else if (record.account?.inventoryCustomFields)
      setSelectedFields(record.account.inventoryCustomFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  useEffect(() => {
    // All inbound charge rules for this account; MANUAL + applicability is filtered at render time
    const fetchManualChargeRules = async () => {
      const accountId =
        record.billToAccountId || record.accountId || record.account?.id;
      if (!accountId) {
        setChargeRules([]);
        return;
      }
      try {
        const rules = await fetchInboundBillingRules(accountId);
        setChargeRules(rules);
      } catch (error) {
        logError(
          "inboundShipments:InboundEdit:TallySheetTab:manualChargeRules",
          error,
          false,
        );
        setChargeRules([]);
      }
    };

    fetchManualChargeRules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record.billToAccountId, record.accountId, record.account?.id]);

  useEffect(() => {
    // Subscribe to form changes to calculate auto charges, est. net weight and total quantity (RAIL + TRUCK)
    const unsubscribe = form.subscribe(
      ({ values }) => {
        const formData = values ?? record;
        setAutoCharges(getAutoCharges(formData, chargeRules));
        const weightUOM =
          formData.scaleWeightUnits || getWeightUOM(record.account, null);
        const net = calcNetWeight(formData, setWeightError, weightUOM);
        const nextNetWeight = net != null ? net : null;
        if (formData?.netWeight !== nextNetWeight) {
          form.change("netWeight", nextNetWeight);
        }
        if (weightUOM && formData?.weightUnits !== weightUOM) {
          form.change("weightUnits", weightUOM);
        }
      },
      { values: true },
    );

    return () => unsubscribe();
  }, [chargeRules, form, record]);

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12} className={classes.arrayInputHeader}>
            <Typography variant="overline" color="textSecondary">
              INBOUND INVENTORY:
            </Typography>
            <CustomFieldsButton
              form={form}
              accountFields={record.account?.inventoryCustomFields}
              selectedCustomFields={record.selectedCustomFields}
              selectedFields={selectedFields}
              setSelectedFields={setSelectedFields}
            />
          </Grid>
          <Grid item xs={12}>
            <ArrayInput
              source="inventories.items"
              label={false}
              className={classes.arrayInput}
            >
              <SimpleFormIterator
                disableReordering={false}
                disableAdd={record.state === InboundState.COMPLETED}
                addButton={
                  <AddCatalogUploadButtons
                    backPath={backPath}
                    form={form}
                    formData={formData}
                    account={record.account}
                    yardCommodity={formData.reloadYardCommodity}
                  />
                }
                removeButton={
                  <EditRemoveButton
                    {...props}
                    record={record}
                    form={form}
                    backPath={backPath}
                    saving={saving}
                    setSaving={setSaving}
                    setWeightError={setWeightError}
                    yardCommodity={yardCommodity}
                  />
                }
              >
                <FormDataConsumer>
                  {({
                    scopedFormData, // The data for this item of the ArrayInput
                    getSource, // Function to get the valid source inside an ArrayInput. Translates to "inventories.items[].property"
                    ...rest
                  }) =>
                    scopedFormData && (
                      <Grid container direction="row" spacing={1}>
                        <Grid
                          container
                          item
                          direction="column"
                          spacing={0}
                          xs={11}
                        >
                          <Grid container direction="row" spacing={1}>
                            <Grid item xs={12} lg={6}>
                              <TextInput
                                source={getSource("productName")}
                                label="Product Name"
                                variant="outlined"
                                fullWidth
                                disabled={
                                  formData.state === InboundState.COMPLETED ||
                                  scopedFormData?.status !== InventoryStatus.NEW
                                }
                                validate={validateRequired}
                                error={
                                  validateTallySheetRow(
                                    formData,
                                    scopedFormData,
                                  ).productName
                                }
                                helperText={false}
                                InputProps={{
                                  endAdornment: (
                                    <>
                                      {exceptionRenderer(scopedFormData)}
                                      {getInfoBubble(formData, scopedFormData)}
                                    </>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={6} lg={3}>
                              {(() => {
                                const isMismatched =
                                  scopedFormData?.quantityPrecount != null &&
                                  scopedFormData.quantityPrecount !==
                                    scopedFormData.quantityAdvised;

                                return (
                                  <NumberInput
                                    source={getSource("quantityAdvised")}
                                    label="Qty Advised"
                                    variant="outlined"
                                    fullWidth
                                    disabled={
                                      formData.state ===
                                        InboundState.COMPLETED ||
                                      scopedFormData?.status !==
                                        InventoryStatus.NEW
                                    }
                                    min="0"
                                    validate={validateQuantity}
                                    error={
                                      validateTallySheetRow(
                                        formData,
                                        scopedFormData,
                                      ).quantityAdvised ||
                                      validateTallyRowQty(scopedFormData)
                                        .quantity ||
                                      isMismatched
                                    }
                                    helperText={false}
                                    InputProps={{
                                      endAdornment: formData.totalUOM,
                                      startAdornment:
                                        scopedFormData?.quantityPrecount !=
                                        null ? (
                                          <InputAdornment position="start">
                                            <span
                                              style={{
                                                color: isMismatched
                                                  ? "error"
                                                  : "inherit",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {`${isMismatched ? "⚠️" : ""} ${scopedFormData.quantityPrecount} /`}
                                            </span>
                                          </InputAdornment>
                                        ) : null,
                                    }}
                                    // onChange={() => handleInventoriesQty(form, setCalcError)}
                                  />
                                );
                              })()}
                            </Grid>
                            {scopedFormData?.status !== InventoryStatus.NEW && (
                              <Grid item xs={6} lg={3}>
                                <NumberInput
                                  source={getSource("quantityReceived")}
                                  label="Qty Received"
                                  variant="outlined"
                                  fullWidth
                                  disabled={
                                    formData.status ===
                                      InboundStatus.IN_TRANSIT ||
                                    formData.status === InboundStatus.ARRIVED ||
                                    formData.state === InboundState.COMPLETED ||
                                    scopedFormData?.status !==
                                      InventoryStatus.NEW
                                  }
                                  min="0"
                                  required={isQuantityReceivedRequired(
                                    formData,
                                    scopedFormData,
                                  )}
                                  error={
                                    validateTallySheetRow(
                                      formData,
                                      scopedFormData,
                                    ).quantityReceived ||
                                    validateTallyRowQty(scopedFormData).quantity
                                  }
                                  helperText={false}
                                />
                              </Grid>
                            )}
                            {isInventoryFieldVisible(
                              InventoryField.PCS,
                              scopedFormData?.reloadYardCommodityId,
                            ) && (
                              <Grid item xs={12} md={3}>
                                <NumberInput
                                  source={getSource("pcs")}
                                  label="Pieces / Unit"
                                  variant="outlined"
                                  fullWidth
                                  min="1"
                                  placeholder={scopedFormData?.product?.pcs}
                                  InputLabelProps={{
                                    shrink:
                                      scopedFormData?.pcs != null ||
                                      scopedFormData?.product?.pcs != null,
                                  }}
                                  validate={validatePieces}
                                  disabled={
                                    scopedFormData?.status !==
                                    InventoryStatus.NEW
                                  }
                                  helperText={false}
                                />
                              </Grid>
                            )}
                            {showWeight(record.account, scopedFormData) &&
                              scopedFormData?.status ===
                                InventoryStatus.NEW && (
                                <Grid item xs={12} md={3}>
                                  <NumberInput
                                    source={getSource("weight")}
                                    label="Weight"
                                    variant="outlined"
                                    fullWidth
                                    min="0"
                                    validate={validateQuantity}
                                    helperText={false}
                                    InputProps={{
                                      endAdornment: `${getWeightUOM(
                                        record.account,
                                        scopedFormData,
                                      )}/${formData.totalUOM}`,
                                    }}
                                  />
                                </Grid>
                              )}
                            <CustomFieldsTallySheet
                              {...props}
                              getSource={getSource}
                              recordFields={scopedFormData?.customFields}
                              accountFields={selectedFields}
                              disabled={
                                scopedFormData?.status !== InventoryStatus.NEW
                              }
                              header={false}
                              width={3}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          item
                          direction="column"
                          spacing={0}
                          xs={1}
                          className={classes.statusIcon}
                        >
                          <InventoryStatusIcon inventory={scopedFormData} />
                        </Grid>
                      </Grid>
                    )
                  }
                </FormDataConsumer>
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Total Load
            </Typography>
            <Grid container direction="row" spacing={1}>
              <Grid item xs={6} md={3}>
                <MuiTextField
                  label="Total Quantity"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled
                  value={calcTotalQuantity(formData) ?? ""}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <SelectInput
                  source="totalUOM"
                  label="Inventory UOM"
                  variant="outlined"
                  fullWidth
                  disabled={record.status === InboundStatus.RELEASED}
                  initialValue="UNIT"
                  choices={getCommodityUnits(yardCommodity)}
                  optionText={unitOptionRenderer}
                  validate={validateRequired}
                  onChange={() => handleUnitChange(form)}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <NumberInput
                  source="netWeight"
                  label="Est. Net Weight"
                  variant="outlined"
                  fullWidth
                  disabled
                  helperText={weightError ? weightError : false}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment:
                      formData.scaleWeightUnits || formData.weightUnits || "",
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {!formData?.skipInvoice && isAuthorized(AclType.INVOICES) && (
            <Grid item xs={12}>
              <fieldset>
                <legend>
                  <Typography variant="overline" color="textSecondary">
                    Billing <NewBadge />
                  </Typography>
                </legend>
                <Grid container spacing={8}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="overline" color="textSecondary">
                      Auto Charges
                    </Typography>
                    <ArrayField
                      record={autoCharges}
                      source="items"
                      label={false}
                      fullWidth
                    >
                      <Datagrid>
                        <FunctionField
                          label="Service"
                          render={(record) => {
                            // Extract service name from serviceNote
                            const parts =
                              record?.serviceNote?.split(" - ") || [];
                            return parts[0] || "";
                          }}
                        />
                        <FunctionField
                          label="Quantity"
                          render={(record) => {
                            const qty = Number(record?.quantity || 0);
                            const units = record?.units || "";
                            return qty ? `${qty} ${getUnitName(units)}` : "";
                          }}
                        />
                        <FunctionField
                          label="Est. Charge"
                          render={(record) => {
                            const amount = Number(record?.amount || 0);
                            return amount ? `$${amount.toFixed(2)}` : "";
                          }}
                        />
                      </Datagrid>
                    </ArrayField>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="overline" color="textSecondary">
                      Manual Charges
                    </Typography>
                    <SmartTipIcon
                      label="manual-charges"
                      alignRight={false}
                      mt={20}
                    />
                    <ArrayInput
                      source="manualCharges.items"
                      label={false}
                      fullWidth
                      disabled={
                        !chargeRules?.length ||
                        Boolean(record?.invoiceId?.trim())
                      }
                    >
                      <SimpleFormIterator disableReordering={true}>
                        <FormDataConsumer>
                          {({ getSource, scopedFormData }) => {
                            const applicableRules = filterApplicableManualRules(
                              formData,
                              chargeRules,
                              ChargeEvent.INBOUND,
                            );
                            const selectedRule = applicableRules.find(
                              (rule) =>
                                rule.id === scopedFormData?.chargeRuleId,
                            );
                            const billingUOM = getUnitName(
                              selectedRule?.billingUOM,
                            );
                            return (
                              <Grid container direction="row" spacing={1}>
                                <Grid item xs={7}>
                                  <SelectInput
                                    source={getSource("chargeRuleId")}
                                    label="Service"
                                    variant="outlined"
                                    fullWidth
                                    disabled={Boolean(
                                      record?.invoiceId?.trim(),
                                    )}
                                    helperText={false}
                                    choices={getManualRuleChoices(
                                      applicableRules,
                                      scopedFormData,
                                    )}
                                    onChange={(value) =>
                                      applyManualRuleDefaultQuantity({
                                        value,
                                        applicableRules,
                                        formData,
                                        scopedFormData,
                                        form,
                                        getSource,
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <NumberInput
                                    source={getSource("quantity")}
                                    label="Quantity"
                                    variant="outlined"
                                    fullWidth
                                    min="0"
                                    validate={validateQuantity}
                                    disabled={Boolean(
                                      record?.invoiceId?.trim(),
                                    )}
                                    helperText={getManualChargeAmount(
                                      selectedRule,
                                      scopedFormData,
                                    )}
                                    InputProps={{
                                      endAdornment: billingUOM,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            );
                          }}
                        </FormDataConsumer>
                      </SimpleFormIterator>
                    </ArrayInput>
                  </Grid>
                </Grid>
              </fieldset>
            </Grid>
          )}
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const syncSelectedTimeslotFromPersistedRecord = ({
  record,
  recordId,
  recordTimeslotId,
  recordTimeslotUpdatedAt,
  selectedTimeslot,
  setSelectedTimeslot,
  prevRecordIdRef,
  prevRecordTimeslotIdRef,
  prevRecordTimeslotUpdatedAtRef,
  afterSync,
  afterClear,
}) => {
  const recordChanged = prevRecordIdRef.current !== recordId;
  const previousTimeslotId = prevRecordTimeslotIdRef.current;
  const previousTimeslotUpdatedAt = prevRecordTimeslotUpdatedAtRef.current;
  const recordTimeslotChanged = previousTimeslotId !== recordTimeslotId;
  const recordTimeslotUpdated =
    recordTimeslotId &&
    previousTimeslotId === recordTimeslotId &&
    previousTimeslotUpdatedAt !== recordTimeslotUpdatedAt;

  prevRecordIdRef.current = recordId;
  prevRecordTimeslotIdRef.current = recordTimeslotId;
  prevRecordTimeslotUpdatedAtRef.current = recordTimeslotUpdatedAt;

  if (record?.timeslot) {
    const localSelectionMatchesPersistedTimeslot =
      !selectedTimeslot || selectedTimeslot.id === recordTimeslotId;
    if (
      recordChanged ||
      recordTimeslotChanged ||
      (recordTimeslotUpdated && localSelectionMatchesPersistedTimeslot)
    ) {
      setSelectedTimeslot(record.timeslot);
      afterSync?.(record.timeslot);
    }
    return;
  }

  if (recordChanged) {
    setSelectedTimeslot(null);
    afterClear?.();
    return;
  }

  if (previousTimeslotId && !recordTimeslotId) {
    setSelectedTimeslot(null);
    afterClear?.();
  }
};

const DispatchTab = ({
  record,
  selectedTimeslot,
  setSelectedTimeslot,
  ...props
}) => {
  const form = useForm();
  const notify = useNotify();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [weightError, setWeightError] = useState(false);
  const advancePrefill = props?.location?.state?.inboundAdvancePrefill;
  const [eventType, setEventType] = useState(record?.timeslot?.eventType);
  const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [notifiedAt, setNotifiedAt] = useState(record?.notifyDateTime || null);
  const [placedAt, setPlacedAt] = useState(record?.placedDateTime || null);
  const [releasedAt, setReleasedAt] = useState(record?.releaseDateTime || null);
  const [collectedAt, setCollectedAt] = useState(
    record?.collectedDateTime || null,
  );
  // Active driver gate check-in, if any. Only trucks check in at the gate, so
  // a rail form does not query for one, and neither does a yard that checks
  // trucks in at the office — it has no check-in rows to find and no gate
  // control to show. Pending status/dock edits live in the form
  // (gateCheckInEdit) and are persisted by the form's primary Save.
  const gateEnabled = sessionYardRunsDriverCheckIn();
  const { checkIn: gateCheckIn, containerRef: gateContainerRef } =
    useActiveGateCheckIn(
      "in",
      gateEnabled && record?.carrierType === CarrierType.TRUCK
        ? record?.id
        : null,
    );
  // A supervisor calls trucks in the published order. Placing a load says the
  // truck reached a dock, so the Time Placed picker below is bound by the same
  // rule as the gate status select — read once here and shared with the gate
  // control, which greys out the statuses the order forbids on this answer.
  const gateQueueTurn = useGateQueueTurn(gateCheckIn);
  const isPlacedBlockedByQueue = !canSetGateStatus({
    status: GateCheckInStatus.DOCKED,
    currentStatus: gateCheckIn?.status,
    orderBound: gateQueueTurn.orderBound,
    isNextInQueue: gateQueueTurn.isNextInQueue,
  });
  const recordId = record?.id || null;
  const recordTimeslotId = record?.timeslot?.id || null;
  const recordTimeslotUpdatedAt = record?.timeslot?.updatedAt || null;
  const prevRecordIdRef = useRef(recordId);
  const prevRecordTimeslotIdRef = useRef(recordTimeslotId);
  const prevRecordTimeslotUpdatedAtRef = useRef(recordTimeslotUpdatedAt);

  // These fields are edited through bare MUI pickers and custom controls, not
  // react-admin inputs, so nothing else registers them with final-form —
  // registration is what makes form.change() on them dirty the form and carry
  // into the submit values. Registered once with cleanup: the previous
  // inline registerField calls added a new subscriber on every render and
  // never released any.
  useEffect(() => {
    const noop = () => {};
    const unsubscribes = [
      "scheduledDateTime",
      "notifyDateTime",
      "placedDateTime",
      "startDateTime",
      "endDateTime",
      "releaseDateTime",
      "collectedDateTime",
      "yardSignatureKey",
      "carrierSignatureKey",
      "gateCheckInEdit",
    ].map((field) => form.registerField(field, noop, { value: true }));
    return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    syncSelectedTimeslotFromPersistedRecord({
      record,
      recordId,
      recordTimeslotId,
      recordTimeslotUpdatedAt,
      selectedTimeslot,
      setSelectedTimeslot,
      prevRecordIdRef,
      prevRecordTimeslotIdRef,
      prevRecordTimeslotUpdatedAtRef,
      afterSync: (timeslot) => setEventType(timeslot.eventType),
      afterClear: () => setEventType(null),
    });
    // Sync persisted timeslot identity/updates only; do not depend on `record`
    // object identity so refetches cannot clobber a pending scheduler pick.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    recordId,
    recordTimeslotId,
    recordTimeslotUpdatedAt,
    setSelectedTimeslot,
  ]);

  useEffect(() => {
    // One-time initialization per record to smooth initial render
    const initFromRecord = () => {
      if (record?.notifyDateTime && !notifiedAt)
        setNotifiedAt(record.notifyDateTime);
      if (record?.placedDateTime && !placedAt)
        setPlacedAt(record.placedDateTime);
      if (record?.releaseDateTime && !releasedAt)
        setReleasedAt(record.releaseDateTime);
      if (record?.collectedDateTime && !collectedAt)
        setCollectedAt(record.collectedDateTime);
    };
    initFromRecord();

    const applyPrefill = () => {
      if (!advancePrefill) return;
      if (
        advancePrefill.field === "notifyDateTime" &&
        !record?.notifyDateTime
      ) {
        setNotifiedAt(advancePrefill.value);
        handleNotifyTime(advancePrefill.value, record);
      } else if (
        advancePrefill.field === "placedDateTime" &&
        !record?.placedDateTime
      ) {
        setPlacedAt(advancePrefill.value);
        handlePlaceTime(advancePrefill.value, record);
      } else if (
        advancePrefill.field === "releaseDateTime" &&
        !record?.releaseDateTime
      ) {
        setReleasedAt(advancePrefill.value);
        form.change("releaseDateTime", advancePrefill.value);
      }
    };

    applyPrefill();
    // Re-apply on next tick to survive any late re-init
    const t = setTimeout(applyPrefill, 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, advancePrefill]);

  const handleNotifyTime = (value, formData) => {
    setNotifiedAt(value);
    form.change("notifyDateTime", value);
    if ((!value || value === "") && formData.placedDateTime) {
      setPlacedAt(value);
      form.change("placedDateTime", value);
      if (formData.startDateTime) form.change("startDateTime", value);
      if (formData.endDateTime) form.change("endDateTime", value);
      if (
        formData.lotType === LotType.PERPETUAL &&
        formData.lotNumberOverride !== true
      )
        form.change(
          "lotNumber",
          autogenLotNumber(
            LotType.PERPETUAL,
            { ...formData, status: InboundStatus.ARRIVED },
            formData?.account,
          ),
        );
    }
  };

  const handlePlaceTime = (value, formData) => {
    setPlacedAt(value);
    form.change("placedDateTime", value);
    if (!formData.notifyDateTime) {
      setNotifiedAt(value);
      form.change("notifyDateTime", value);
    }
    if (
      formData.lotType === LotType.PERPETUAL &&
      formData.lotNumberOverride !== true
    ) {
      form.change(
        "lotNumber",
        autogenLotNumber(
          LotType.PERPETUAL,
          {
            ...formData,
            placedDateTime: value,
            status: formData.sit
              ? InboundStatus.SIT_PLACED
              : InboundStatus.PLACED,
          },
          formData.account,
        ),
      );
    }
    if (!value || value === "") {
      if (formData.startDateTime) form.change("startDateTime", value);
      if (formData.endDateTime) form.change("endDateTime", value);
    }
    // A placed load is at the dock — advance the pending gate status with the
    // stamp. Only forward from the waiting statuses so editing the placed time
    // never downgrades a check-in already completed or cancelled.
    if (value && value !== "") setGateStatusForward(GateCheckInStatus.DOCKED);
  };

  const {
    setGateEdit,
    setGateStatusForward,
    startManualGateCheckIn,
    handleGateStatus,
    handleGateDock,
    handleGateAtDock,
  } = createStagedGateEdit({
    form,
    gateCheckIn,
    notify,
    fields: {
      // The inbound arrival stamp is the notified time — the field this
      // direction's status derives from.
      arrivalField: "notifyDateTime",
      placedField: "placedDateTime",
      setArrival: handleNotifyTime,
      // handlePlaceTime also re-derives the perpetual lot number, which the
      // save path keys off placedDateTime.
      setPlaced: handlePlaceTime,
      isAtDockBlocked: (formData) =>
        Boolean(formData.placedDateTime || formData.releaseDateTime),
      // The gate rule the crew Gate Queue and saveGateCheckIn apply — carrier
      // and trailer, then inventory (not SIT) — so DOCKED is refused here for
      // exactly the shipments they refuse to place. The record is merged under
      // the form values because the form only holds what its own tabs put there.
      atDockRefusalReason: (formData) =>
        gatePlacementRefusal({ ...record, ...formData }, false),
      canStampRelease: (formData) =>
        !formData.releaseDateTime &&
        !isReleasedTimeDisabled({ formData, record, placedAt }),
      // The load as the departure rule sees it: the form only holds what its
      // own tabs put there, so the record sits under the form values.
      shipmentOf: (formData) => ({ ...record, ...formData }),
      setRelease: (stamp) => {
        setReleasedAt(stamp);
        form.change("releaseDateTime", stamp);
      },
    },
  });

  const handleStartTime = (value) => {
    form.change("startDateTime", value);

    if (!value || value === "") {
      form.change("endDateTime", value);
    }
  };

  const handleEndTime = (value) => {
    form.change("endDateTime", value);

    if (!value || value === "") {
      form.change("startDateTime", value);
    }
  };

  const getActualGross = (formData) => {
    if (
      formData.tareWeight !== null &&
      formData.tareWeight >= 0 &&
      formData.ladenWeight >= 0 &&
      (formData.weightUnits || formData.scaleWeightUnits)
    ) {
      return `Gross Weight: ${formData.ladenWeight - formData.tareWeight} ${
        formData.weightUnits ? formData.weightUnits : formData.scaleWeightUnits
      }`;
    } else return true;
  };

  const handleScaleUnitsChange = (event, formData) => {
    const netWeight = calcNetWeight(
      formData,
      setWeightError,
      event.target.value,
    );
    form.change("netWeight", netWeight != null ? netWeight : null);
    form.change("weightUnits", event.target.value || null);
  };

  const getReleaseDateTimeHelperText = (formData) => {
    if (isReleaseBlockedByCommitment(record)) {
      return "Has inventory committed to a pending outbound.";
    } else {
      return getHoursMinutesDuration(
        "Cycle Time:",
        formData.placedDateTime,
        formData.releaseDateTime,
      );
    }
  };

  const isReleasedTimeDisabled = ({ formData, record, placedAt }) => {
    // Releasing ships the railcar's inventory out; a SIT car's release closes
    // its inventory the same way, so both refuse the stamp while an outbound
    // is still waiting on that quantity.
    const committedToOutbound = isReleaseBlockedByCommitment(record);

    const sitDisabled =
      !record?.placedDateTime ||
      formData?.status === InboundStatus.RELEASED ||
      committedToOutbound;

    // DO NOT CHANGE OR INVENTORY COUNTS WILL BE INCONSISTENT ON STATUS ROLLBACK !!!
    const nonSitDisabled =
      (!formData?.placedDateTime && !placedAt) ||
      !formData?.endDateTime ||
      formData?.state !== InboundState.COMPLETED ||
      formData?.status === InboundStatus.RELEASED ||
      committedToOutbound;

    return formData?.sit ? sitDisabled : nonSitDisabled;
  };

  const handleTimeslot = (timeslot) => {
    if (timeslot) {
      const scheduledDate = resolveScheduledDateTime(timeslot, {
        notify,
        scope: "inboundShipments:InboundEdit:DispatchTab:handleTimeslot",
      });
      if (!scheduledDate) return;
      form.change("scheduledDateTime", scheduledDate);
      setSelectedTimeslot(timeslot);
      setEventType(timeslot.eventType);
    } else {
      form.change("scheduledDateTime", null);
      setSelectedTimeslot(null);
    }
  };

  const handleSchedulerOpen = (event, formData) => {
    event.preventDefault();
    event.stopPropagation();
    if (!formData.placedDateTime) setIsSchedulerOpen(true);
  };

  const getSchedulerHelperText = (formData) => {
    if (!window.appUser.reloadYard.eventTypes?.items?.length)
      return `Setup Schedule and Event Type to enable.`;
    if (formData?.placedDateTime)
      return "Placed shipments cannot be rescheduled.";
    return eventType?.name || "";
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <Grid container direction="column" spacing={1}>
            <Grid container direction="row" spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                style={{ display: "flex", alignItems: "flex-start", gap: 8 }}
              >
                <DateTimePicker
                  label="Time Scheduled"
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  fullWidth
                  disabled={formData.placedDateTime}
                  onClickCapture={(event) =>
                    handleSchedulerOpen(event, formData)
                  }
                  value={
                    !formData.scheduledDateTime
                      ? null
                      : getDateTimeFromUtc(formData.scheduledDateTime)
                  }
                  format="MM/dd/yyyy hh:mm a"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CreatedAtIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={() => {}}
                  helperText={getSchedulerHelperText(formData)}
                />
                <Box mt={0.5}>
                  <IconButtonWithTooltip
                    label="Calendar"
                    color="default"
                    size="large"
                    onClick={() => setIsCalendarOpen(true)}
                  >
                    <CalendarIcon />
                  </IconButtonWithTooltip>
                </Box>
                <Scheduler
                  account={record.account}
                  eventType={eventType}
                  setEventType={setEventType}
                  selectedTimeslot={selectedTimeslot}
                  setSelectedTimeslot={handleTimeslot}
                  open={isSchedulerOpen}
                  setIsOpen={setIsSchedulerOpen}
                  resettable={true}
                  workflow={Workflow.INBOUND}
                />
                {isCalendarOpen && (
                  <EventsCalendarDialog
                    eventType={eventType}
                    selectedTimeslot={selectedTimeslot}
                    persistedTimeslotId={record?.timeslot?.id}
                    account={record.account}
                    onTimeslotPick={handleTimeslot}
                    isOpen={isCalendarOpen}
                    setIsOpen={setIsCalendarOpen}
                  />
                )}
              </Grid>
              {/* Manage the driver's gate check-in without leaving the form
                  for the Gate Queue page, and check a truck in from here when
                  the driver could not do it from the kiosk. Only trucks check
                  in at the gate, so a rail form does not query for one, and a
                  yard that checks trucks in at the office runs no gate at all.
                  The record is merged under the form values for the same
                  reason DialogSaveButton merges it before minting the row: the
                  form only holds what its own tabs put there. */}
              <Grid item xs={12} md={8}>
                {gateEnabled && formData.carrierType === CarrierType.TRUCK && (
                  <GateCheckInControl
                    checkIn={gateCheckIn}
                    containerRef={gateContainerRef}
                    onAtDock={handleGateAtDock}
                    queueTurn={gateQueueTurn}
                    shipment={{ ...record, ...formData }}
                    manualCheckIn={{
                      pending: wantsManualGateCheckIn(
                        { ...record, ...formData },
                        false,
                      ),
                      onCheckIn: canOfferManualGateCheckIn(
                        { ...record, ...formData },
                        false,
                      )
                        ? startManualGateCheckIn
                        : null,
                    }}
                    editor={{
                      status:
                        formData.gateCheckInEdit?.status ??
                        gateCheckIn?.status ??
                        "",
                      dock:
                        formData.gateCheckInEdit?.dockAssignment ??
                        gateCheckIn?.dockAssignment ??
                        "",
                      driverName:
                        formData.gateCheckInEdit?.driverName ??
                        gateCheckIn?.driverName ??
                        "",
                      truckPlate:
                        formData.gateCheckInEdit?.truckPlate ??
                        gateCheckIn?.truckPlate ??
                        "",
                      setStatus: handleGateStatus,
                      setDock: handleGateDock,
                      setDriverName: (value) =>
                        setGateEdit({ driverName: value }),
                      setTruckPlate: (value) =>
                        setGateEdit({ truckPlate: value }),
                    }}
                  />
                )}
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Time Notified"
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  fullWidth
                  disabled={
                    formData.status === InboundStatus.RELEASED ||
                    formData.placedDateTime ||
                    placedAt
                  }
                  disableFuture
                  showTodayButton
                  clearable
                  value={notifiedAt || null}
                  maxDate={formData.placedDateTime}
                  maxDateMessage="Date should be before Placed Time"
                  format="MM/dd/yyyy hh:mm a"
                  onChange={(value) => handleNotifyTime(value, formData)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <ArrivedAtIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {formData.carrierType === CarrierType.TRUCK && (
                <Grid item xs={12} md={4}>
                  <CarrierNameInput
                    source="carrierName"
                    label="Carrier Name"
                    disabled={
                      record.carrierName &&
                      record.status === InboundStatus.RELEASED
                    }
                    validate={validateCarrierName}
                    isRequired={isCarrierNameRequired(formData)}
                  />
                </Grid>
              )}
              {formData.carrierType === CarrierType.TRUCK && (
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="railCarNumber"
                    label="Trailer Number"
                    variant="outlined"
                    fullWidth
                    disabled={
                      record.railCarNumber &&
                      record.status === InboundStatus.RELEASED
                    }
                    parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                    validate={validateRailCarNumber}
                    required={isRailcarNumberRequired(formData)}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <CopyToClipboardButton
                            text={formData.railCarNumber || ""}
                            edge="end"
                            fontSize="small"
                            mb={0}
                          />
                        </InputAdornment>
                      ),
                    }}
                    helperText={false}
                  />
                </Grid>
              )}
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Time Placed"
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  fullWidth
                  disabled={
                    // No inventory, no placement — unless the car is SIT, or a
                    // placed time already exists and is only being edited.
                    (!canPlaceInboundShipment(formData) &&
                      !formData.placedDateTime &&
                      !placedAt) ||
                    formData.status === InboundStatus.RELEASED ||
                    formData.startDateTime ||
                    // A truck that has not been called forward is not at a
                    // dock. Stamping this field advances the gate row to
                    // DOCKED, which the queue would refuse at the save — so
                    // the refusal is shown here instead of after the work.
                    isPlacedBlockedByQueue
                  }
                  {...(isPlacedBlockedByQueue && {
                    // Red text behind a warning glyph, matching the overdue
                    // account warning on AccountDropDown. Spread only when
                    // blocked: error/helperText passed as undefined would
                    // clobber the picker's own min/maxDateMessage text.
                    error: true,
                    helperText: `⚠️ ${outOfTurnTooltip(
                      gateQueueTurn.nextLabel,
                    )}`,
                  })}
                  value={placedAt || null}
                  minDate={formData.notifyDateTime || undefined}
                  minDateMessage="Date should be after Notified Time"
                  maxDate={formData.releaseDateTime || undefined}
                  maxDateMessage="Date should be before Released Time"
                  format="MM/dd/yyyy hh:mm a"
                  onChange={(value) => handlePlaceTime(value, formData)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PlacedAtIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {formData.carrierType === CarrierType.TRUCK && (
                <>
                  <Grid item xs={12} md={4}>
                    <NumberInput
                      source="ladenWeight"
                      label="Laden Weight"
                      variant="outlined"
                      fullWidth
                      disabled={
                        Boolean(record?.invoiceId?.trim()) ||
                        !formData.placedDateTime
                      }
                      min="0"
                      validate={(value, allValues) =>
                        allValues.tareWeight
                          ? validateLadenWeight(value)
                          : validateLoadedMinNum(value)
                      }
                      required={isLadenWeightRequired(formData)}
                      helperText={false}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">{`${
                            formData.scaleWeightUnits || ""
                          }`}</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <SelectInput
                      source="scaleWeightUnits"
                      label="Units"
                      variant="outlined"
                      fullWidth
                      disabled={
                        Boolean(record?.invoiceId?.trim()) ||
                        formData.inventories?.items?.length === 0
                      }
                      choices={UnitWeightOptions}
                      optionText={unitOptionRenderer}
                      allowEmpty
                      // defaultValue={Unit.CWT} -- removing to keep form pristine
                      validate={
                        formData.tareWeight || formData.ladenWeight
                          ? validateRequired
                          : undefined
                      }
                      onChange={(event) =>
                        handleScaleUnitsChange(event, formData)
                      }
                      helperText={false}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Unload Start Time"
                  fullWidth
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  disabled={
                    !formData.startDateTime ||
                    record.status === InboundStatus.RELEASED ||
                    (isBulkArea(formData.areaId) &&
                      [
                        InboundState.PROCESS_INVENTORY,
                        InboundState.COMPLETED,
                      ].includes(record.state))
                  }
                  value={
                    formData.startDateTime === ""
                      ? null
                      : formData.startDateTime
                  }
                  onChange={(value) => handleStartTime(value)}
                  minDate={formData.placedDateTime}
                  minDateMessage="Date should be after Placed Time"
                  format="MM/dd/yyyy hh:mm a"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <TimerIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Unload End Time"
                  fullWidth
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  disabled={
                    !formData.endDateTime ||
                    record.status === InboundStatus.RELEASED ||
                    (isBulkArea(formData.areaId) &&
                      record.state === InboundState.COMPLETED)
                  }
                  value={
                    formData.endDateTime === "" ? null : formData.endDateTime
                  }
                  onChange={(value) => handleEndTime(value)}
                  minDate={formData.startDateTime}
                  minDateMessage="Date should be after Start Time"
                  format="MM/dd/yyyy hh:mm a"
                  helperText={getHoursMinutesDuration(
                    "Unload Time:",
                    formData.startDateTime,
                    formData.endDateTime,
                  )}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <TimerOffIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {formData.carrierType === CarrierType.TRUCK && (
                <>
                  <Grid item xs={12} md={4}>
                    <NumberInput
                      source="tareWeight"
                      label="Tare Weight"
                      variant="outlined"
                      fullWidth
                      disabled={
                        Boolean(record?.invoiceId?.trim()) ||
                        formData.state !== InboundState.COMPLETED
                      }
                      min="0"
                      validate={validateTareWeight}
                      required={isTareWeightRequired(formData)}
                      helperText={getActualGross(formData)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">{`${
                            formData.scaleWeightUnits || ""
                          }`}</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <NumberInput
                      source="netWeight"
                      label="Est. Net Weight"
                      variant="outlined"
                      fullWidth
                      disabled
                      helperText={weightError ? weightError : false}
                      inputLabelProps={{ shrink: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">{`${
                            formData.scaleWeightUnits ||
                            formData.weightUnits ||
                            ""
                          }`}</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Time Released"
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  fullWidth
                  disabled={isReleasedTimeDisabled({
                    formData,
                    record,
                    placedAt,
                  })}
                  value={releasedAt || null}
                  minDate={formData.placedDateTime}
                  minDateMessage="Date should be after Placed Time"
                  format="MM/dd/yyyy hh:mm a"
                  onChange={(value) => {
                    setReleasedAt(value);
                    form.change("releaseDateTime", value);
                    // A released load has left the gate too.
                    if (value) setGateStatusForward(GateCheckInStatus.DEPARTED);
                  }}
                  helperText={getReleaseDateTimeHelperText(formData)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <ReleasedAtIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {!formData?.skipSignature &&
                formData.carrierType === CarrierType.TRUCK &&
                isAuthorized(AclType.OUTBOUND_SIGN) &&
                !isXSmall && (
                  <SignatureBlock
                    formData={formData}
                    form={form}
                    record={record}
                    updateShipmentMini={updateLambdaInboundMini}
                  />
                )}
            </Grid>
            {record.carrierType === CarrierType.RAIL && (
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={4}>
                  <DateTimePicker
                    label="Time Pulled"
                    disableFuture
                    showTodayButton
                    clearable
                    margin="dense"
                    inputVariant="outlined"
                    variant="dialog"
                    fullWidth
                    // DO NOT CHANGE OR INVENTORY COUNTS WILL BE INCONSISTENT ON STATUS ROLLBACK !!!
                    disabled={!formData.releaseDateTime && !releasedAt}
                    value={collectedAt || null}
                    minDate={formData.releaseDateTime}
                    minDateMessage="Date should be after Released Time"
                    format="MM/dd/yyyy hh:mm a"
                    onChange={(value) => {
                      setCollectedAt(value);
                      form.change("collectedDateTime", value);
                    }}
                    // Placed through pulled, both days counted.
                    helperText={
                      formData.collectedDateTime
                        ? `Storage Days: ${
                            getYardCalendarDaysInclusive(
                              formData.placedDateTime,
                              formData.collectedDateTime,
                            ) ?? 0
                          }`
                        : false
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <CollectedAtIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        )}
      </FormDataConsumer>
    </MuiPickersUtilsProvider>
  );
};

const EditToolbar = ({
  loading,
  operatingAccount,
  selectedTimeslot,
  ...props
}) => {
  const classes = useStyles();
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <Toolbar style={{ justifyContent: "space-between" }}>
      <Backdrop className={classes.backdrop} open={isSaving || isDeleting}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogSaveButton
        {...props}
        operatingAccount={operatingAccount}
        selectedTimeslot={selectedTimeslot}
        validateTallySheetSaved={validateTallySheetSaved}
        validateTallyQty={validateTallyQty}
        loading={loading}
        isSaving={isSaving}
        setIsSaving={setIsSaving}
        isDeleting={isDeleting}
      />
      <DeepDeleteButton
        {...props}
        isSaving={isSaving}
        isDeleting={isDeleting}
        setIsDeleting={setIsDeleting}
      />
    </Toolbar>
  );
};

export const InboundEdit = (props) => {
  const isMedium = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const { record, loading } = useEditController(props);
  const [receiptFile, setReceiptFile] = useState();
  const [receiptNumber, setReceiptNumber] = useState();
  const [photos, setPhotos] = useState(record?.photos?.items || []);
  const [exceptions, setExceptions] = useState({});
  const [allSealsValid, SetAllSealsValid] = useState(false);
  const [yardCommodity, setYardCommodity] = useState(
    record?.reloadYardCommodity,
  );
  const [operatingAccount, setOperatingAccount] = useState(record?.account);
  const [selectedTimeslot, setSelectedTimeslot] = useState(record?.timeslot);
  const recordId = record?.id || null;
  const recordTimeslotId = record?.timeslot?.id || null;
  const recordTimeslotUpdatedAt = record?.timeslot?.updatedAt || null;
  const prevRecordIdRef = useRef(recordId);
  const prevRecordTimeslotIdRef = useRef(recordTimeslotId);
  const prevRecordTimeslotUpdatedAtRef = useRef(recordTimeslotUpdatedAt);
  // SIT railcars fall back to the SIT Cars list instead of /inboundShipments.
  const backPath = getInboundBackPath(props, record);

  useEffect(() => {
    if (record?.account) setOperatingAccount(record.account);
  }, [record?.account]);

  useEffect(() => {
    syncSelectedTimeslotFromPersistedRecord({
      record,
      recordId,
      recordTimeslotId,
      recordTimeslotUpdatedAt,
      selectedTimeslot,
      setSelectedTimeslot,
      prevRecordIdRef,
      prevRecordTimeslotIdRef,
      prevRecordTimeslotUpdatedAtRef,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordId, recordTimeslotId, recordTimeslotUpdatedAt]);

  useEffect(() => {
    if (record) {
      setExceptions({
        hasException: record.hasException,
        unsafeShipment: record.unsafeShipment,
        unsafeShipmentNote: record.unsafeShipmentNote,
        brokenSeal: record.brokenSeal,
        brokenSealNote: record.brokenSealNote,
        otherException: record.otherException,
        otherExceptionNote: record.otherExceptionNote,
      });
      setYardCommodity(record.reloadYardCommodity);
      if (record.photos?.items?.length > 0) {
        setPhotos(record.photos.items);
      }
    }
  }, [record]);

  if (!record) return <Loading />;
  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Inbound" />}
      mutationMode="pessimistic"
      actions={
        <InboundEditActions
          {...props}
          loading={loading}
          backPath={backPath}
          setReceiptFile={setReceiptFile}
          setReceiptNumber={setReceiptNumber}
          exceptions={exceptions}
          setExceptions={setExceptions}
          allSealsValid={allSealsValid}
        />
      }
      aside={
        <InboundAside
          {...props}
          backPath={backPath}
          record={record}
          exceptions={exceptions}
          photos={photos}
        />
      }
    >
      {record?.status === InboundStatus.ADVICE_PROCESSING ? (
        <TabbedForm
          variant="outlined"
          submitOnEnter={false}
          toolbar={
            <EditToolbar
              {...props}
              backPath={backPath}
              record={record}
              loading={loading}
              operatingAccount={operatingAccount}
              selectedTimeslot={selectedTimeslot}
            />
          }
          validate={(values) => validateInboundEdit(record, values)}
        >
          <FormTab path={""} label="Inbound Setup">
            <ShipmentSetupTab
              {...props}
              record={record}
              backPath={backPath}
              receiptFile={receiptFile}
              receiptNumber={receiptNumber}
              exceptions={exceptions}
              yardCommodity={yardCommodity}
              setYardCommodity={setYardCommodity}
              SetAllSealsValid={SetAllSealsValid}
              photos={photos}
              setPhotos={setPhotos}
            />
          </FormTab>
          <FormTab path={"notes"} label="Notes">
            <NotesTab />
          </FormTab>
          {isMedium && (
            <FormTab path={"historyLog"} label="History Log">
              <HistoryTab />
            </FormTab>
          )}
        </TabbedForm>
      ) : (
        <TabbedForm
          variant="outlined"
          submitOnEnter={false}
          toolbar={
            <EditToolbar
              {...props}
              backPath={backPath}
              record={record}
              loading={loading}
              operatingAccount={operatingAccount}
              selectedTimeslot={selectedTimeslot}
            />
          }
          validate={(values) => validateInboundEdit(record, values)}
        >
          <FormTab path={""} label="Inbound Setup">
            <ShipmentSetupTab
              {...props}
              record={record}
              backPath={backPath}
              receiptFile={receiptFile}
              receiptNumber={receiptNumber}
              exceptions={exceptions}
              yardCommodity={yardCommodity}
              setYardCommodity={setYardCommodity}
              SetAllSealsValid={SetAllSealsValid}
              photos={photos}
              setPhotos={setPhotos}
            />
          </FormTab>
          <FormTab path={"tallySheet"} label="Tally Sheet">
            {/* Must pass ...props or props not propagated to InventoryEditButton */}
            <TallySheetTab
              {...props}
              backPath={backPath}
              record={record}
              yardCommodity={yardCommodity}
            />
          </FormTab>
          {!record.sit && (
            <FormTab
              path={"checklist"}
              label={
                <span>
                  Checklist
                  <BetaBadge />
                </span>
              }
            >
              <ChecklistForm
                {...props}
                account={record.account}
                yardCommodity={yardCommodity}
                isDisabled={record.status === InboundStatus.RELEASED}
              />
            </FormTab>
          )}
          <FormTab path={"dispatch"} label="Dispatch">
            <DispatchTab
              {...props}
              record={record}
              selectedTimeslot={selectedTimeslot}
              setSelectedTimeslot={setSelectedTimeslot}
            />
          </FormTab>
          <FormTab path={"notes"} label="Notes">
            <NotesTab />
          </FormTab>
          {isMedium && (
            <FormTab path={"historyLog"} label="History Log">
              <HistoryTab />
            </FormTab>
          )}
        </TabbedForm>
      )}
    </Edit>
  );
};
